module.exports = __webpack_public_path__ + "img/facebook-post.2f7d3335.svg";